var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emailBar"},[_c('a',{class:{ active: _vm.hover },attrs:{"href":"mailto:soboleskijoe@gmail.com"},on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._v(" soboleskijoe@gmail.com ")]),_c('div',{staticClass:"border"})])
}
var staticRenderFns = []

export { render, staticRenderFns }